"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.ai.chat': 'Chat IA',
};
